import React from 'react';
import '../Pages/CSS/Contact.css';

const Contact = () => {

  return (
    <div className='contact'>
      <div className='contact-header'>
        <h2>talk to me :)</h2>
        <h3>...about order issues, commissions, or life</h3>
      </div>
      <div className='contact-info'>
        <p><strong>instagram:</strong> @gecko.onawall</p>
        <p><strong>email:</strong> geckoonawall@gmail.com</p>
        <p><strong>phone:</strong> (669) 268-4051</p>
      </div>
      <div className='contact-location'>
        <h3><strong>current location for hand delivery: CHAMPAIGN, IL</strong></h3>
      </div>
    </div>
  )
}

export default Contact;
